const entity = {
  name: {
    singular: 'Evento',
    plural: 'Eventos'
  },
  styles: {
    gridTemplateColumns: '30% 1fr',
    gridTemplateAreas: '"main secondary"'
  },
  collection: 'events',
  tableHeaders: [
    { text: 'Título', value: 'title', type: 'string' },
    { text: 'Url Amigável', value: 'slug', type: 'string' },
    { text: 'Data ', value: 'dateBegin', type: 'date' },
    { text: 'Atualizado em', value: 'updatedAt', type: 'date' },
    { text: 'Entrada ', value: 'dateIn', type: 'date' },
    { text: 'Saída', value: 'dateOut', type: 'date' },
    { text: 'Publicado', value: 'published', type: 'boolean' },
    { text: 'Actions', value: 'action', sortable: false }
  ],
  model: {
    title: '',
    summary: '',
    fileTeaser: '',
    fileTeaserMobile: '',
    dateBegin: null,
    dateEnd: null,
    body: '',
    styles: '',
    slug: '',
    attendees: '',
    published: false
  },
  config: {
    name: 'Config',
    hasPreview: true,
    fields: [
      {
        type: 'url',
        label: 'Url amigável',
        model: 'slug',
        required: true
      },
      {
        type: 'date-picker',
        label: 'Início',
        model: 'dateBegin',
        required: false,
        size: 'xs12 sm12 md6 lg6'
      },
      {
        type: 'date-picker',
        label: 'Término',
        model: 'dateEnd',
        required: false,
        size: 'xs12 sm12 md6 lg6'
      },
      {
        type: 'switch',
        model: 'published',
        label: 'Publicado'
      }
    ]
  },
  schema: {
    groups: [
      {
        name: 'Conteúdo',
        fields: [
          {
            type: 'text-field',
            label: 'Título',
            model: 'title',
            required: true
          },
          {
            type: 'text-field',
            label: 'Resumo',
            model: 'summary',
            required: false
          },
          {
            type: 'single-file',
            label: 'Imagem do Topo',
            model: 'fileTeaser',
            hideInput: true,
            size: 'xs12 sm12 md6 lg6'
          },
          {
            type: 'single-file',
            label: 'Mobile',
            model: 'fileTeaserMobile',
            hideInput: true,
            size: 'xs12 sm12 md6 lg6'
          },
          {
            type: 'editor',
            label: 'Conteúdo',
            model: 'body',
            required: false
          }
        ]
      }
    ]
  },
  formOptions: {
    validateAfterLoad: true,
    validateAfterChanged: true,
    validateAsync: true
  }
}

export default [
  {
    path: '/events',
    meta: {
      entity,
      requiresAuth: true,
      requiresPermissionTo: 'events'
    },
    component: () => import(/* webpackChunkName: 'events' */ '../../../views/Crud.vue')
  }, {
    path: '/events/new',
    meta: {
      entity,
      requiresAuth: true,
      requiresPermissionTo: 'events'
    },
    component: () => import(/* webpackChunkName: 'events' */ '../../../views/Crud.vue')
  }, {
    path: '/events/:id',
    meta: {
      entity,
      requiresAuth: true,
      requiresPermissionTo: 'events'
    },
    component: () => import(/* webpackChunkName: 'events' */ '../../../views/Crud.vue')
  }
]
